var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeWithoutBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1771 6.5L24.1775 6.5C26.1517 6.49831 27.982 7.26251 29.3696 8.63835C32.2104 11.4703 32.2101 16.0727 29.3691 18.9039L20.2118 28.0018L20.2118 28.0018L20.2071 28.0066C19.8965 28.3235 19.4698 28.5 19.004 28.5C18.5382 28.5 18.1115 28.3235 17.8008 28.0065L17.8009 28.0065L17.7962 28.0018L8.63892 18.9039C5.77099 16.046 5.78882 11.4273 8.68214 8.59577L8.68276 8.59517C10.0512 7.25128 11.8554 6.53613 13.8312 6.51798C14.6655 6.52278 15.5075 6.84701 16.3405 7.34779C17.1738 7.84872 17.9582 8.50125 18.6785 9.11791L19.0083 9.40025L19.3341 9.11336C20.047 8.48563 20.8311 7.82706 21.664 7.32489C22.4981 6.82197 23.3426 6.5 24.1771 6.5Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeWithoutBg);
export default __webpack_public_path__ + "static/media/likeWithoutBg.df8f182baea411704bca9174c1f2a783.svg";
export { ForwardRef as ReactComponent };